const contactForm = {
  page: {
    title: 'IhreApotheken.de kontaktieren',
    description: 'Bei Fragen, Anmerkungen oder Wünschen an das IhreApotheken.de-Team nutzen Sie bitte das untenstehende Kontaktformular. Wir freuen uns auf Ihr Feedback und kümmern uns zeitnah um Ihr Anliegen.',
  },
  forms: {
    salutation: 'Anrede',
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    phoneNumber: 'Telefonnummer',
    email: 'E-Mail-Adresse *',
    message: 'Ihre Nachricht *',
    ourPromise: '{strongText} Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
    ourPromiseTitle: 'Unser Versprechen:',
    policy: {
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzbestimmungen',
      1: 'Die',
      2: 'und',
      3: 'habe ich zur Kenntnis genommen und bin mit ihrer Geltung einverstanden.',
    },
    pleaseFill: '* Bitte füllen Sie die Pflichtfelder aus',
    send: 'Senden',
  },
  success: {
    title: 'Kontaktformular',
    description: 'Vielen Dank für Ihre Nachricht an das Team von IhreApotheken.de. Wir haben eine Kopie Ihrer Nachricht an die von Ihnen angegebene E-Mail-Adresse gesendet.',
    button: 'Zur Startseite',
  },
  advantage: {
    title: 'Sie haben Fragen an die Apotheke?',
    description: 'Bei Fragen zu Produkten oder anderen Gesundheitsthemen können Sie das Apothekenteam direkt kontaktieren.',
    button: 'Jetzt kontaktieren',
  },
}

export default contactForm
